import type { FC } from 'react';
import { Tooltip } from '@mui/material';
import { useTranslationResponse } from '@isomorphic/hooks/use-translation-response';

import { isTruncatedLink } from '@utils/common';
import { SimpleLink } from '@shared';
import type { NavTreeItem } from '@models/NavigationTree';
import { NavArrow } from '../NavArrow/NavArrow';
import { NavLinkWrapper } from '../../Navigation.styles';

type NavLinkProps = { item: NavTreeItem; isOpened: boolean };

export const NavLink: FC<NavLinkProps> = ({ item, isOpened }) => {
  const linkNavTitle: string = useTranslationResponse(item.title, 'navigation') || 'Empty title';
  const isDirectory = Boolean(item.children?.length);

  if (isTruncatedLink(item) && item.title) {
    return (
      <NavLinkWrapper>
        <NavArrow isOpened={isOpened} isDirectory={isDirectory} />
        <Tooltip title={`${item.title}`}>
          <span>
            <SimpleLink href={item.href}>{linkNavTitle}</SimpleLink>
          </span>
        </Tooltip>
      </NavLinkWrapper>
    );
  }

  return (
    <NavLinkWrapper className={item.preventRedirect ? 'prevent-redirect' : ''}>
      <NavArrow isOpened={isOpened} isDirectory={isDirectory} />
      <SimpleLink href={item.href}>{linkNavTitle}</SimpleLink>
    </NavLinkWrapper>
  );
};
